import ATextarea from './a-textarea.vue'

export default ATextarea
